import React from "react";

type StepsWizardType = {
  currStep: number;
  steps: any[];
};

const StepsWizard = ({ currStep, steps }: StepsWizardType) => {
  return (
    <div className="stepsBox">
      {steps.map((step) => (
        <div
          className={`stepContainer ${step.number < currStep ? "past" : ""} ${
            step.number === currStep ? "active" : ""
          }`}
          key={step.number}
        >
          <div className="step">{step.number}</div>
          <p className="text">{step.text}</p>
        </div>
      ))}
    </div>
  );
};

export default StepsWizard;
